import React from "react";
import styled from "styled-components";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Password } from "primereact/password";

const StyledInputText = styled(InputText)`
  min-width: 210px;
`;

export const FloatWrapper = styled.div`
  padding-top: 20px;
`;

const StyledCheckBoxLabel = styled.label`
  margin-left: .5rem;
  line-height: 1;
`

const CheckBoxWrapper = styled.div`
  display: flex;  
  align-items: center;
`

export const TextField = props => {
  return (
    <FloatWrapper>
      <span className="p-float-label">
        <StyledInputText
          id={props.id}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
        />
        <label htmlFor={props.id}>{props.label}</label>
      </span>
    </FloatWrapper>
  );
};

export const PasswordField = props => {
  return (
    <FloatWrapper>
      <span className="p-float-label">
        <Password
          id={props.id}
          value={props.value}
          onChange={props.onChange}
          onKeyDown={props.onKeyDown}
          feedback={false}
        />
        <label htmlFor={props.id}>{props.label}</label>
      </span>
    </FloatWrapper>
  );
};

export const DateField = props => {
  return (
    <FloatWrapper>
      <span className="p-float-label">
        <Calendar
          id={props.id}
          value={new Date(props.value)}
          onChange={props.onChange}
          showIcon={true}
          touchUI={true}
        />
        <label htmlFor={props.id}>{props.label}</label>
      </span>
    </FloatWrapper>
  );
};

export const CheckboxComponent = props => {
  return (
    <CheckBoxWrapper>
      <Checkbox
        inputId={props.id}
        value={props.value}
        onChange={props.onChange}
        checked={props.checked}
      />
      <StyledCheckBoxLabel htmlFor={props.id}>
        {props.label}
      </StyledCheckBoxLabel>
    </CheckBoxWrapper>
  );
};

export const ButtonComponent = props => {
  return (
    <FloatWrapper>
      <Button {...props} />
    </FloatWrapper>
  );
};
